import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import { isEmpty } from '@elliemae/ds-utilities/utils';
import pipe from './converPropsToFormModifiers.js';
import pipe$1 from './convertPropsToLayoutModifiers.js';
import pipe$2 from './convertPropToFeedBackModifiers.js';
import pipe$3 from './convertPropsToSizeModifiers.js';
import pipe$4 from './convertPropsToTextModifiers.js';
import pipe$5 from './convertPropsToColorModifiers.js';

var DimsumConfig = {
  classNamePrefix: 'em-ds',
};

var cssPrefix = "".concat(DimsumConfig.classNamePrefix, "-");

var executePipelines = function executePipelines(props) {
  var form = pipe().execute(props);
  var layout = pipe$1().execute(props);
  var feedback = pipe$2().execute(props);
  var size = pipe$3().execute(props);
  var text = pipe$4().execute(props);
  var color = pipe$5().execute(props);
  return [].concat(_toConsumableArray(form), _toConsumableArray(layout), _toConsumableArray(feedback), _toConsumableArray(size), _toConsumableArray(text), _toConsumableArray(color));
};
/**
 * Docs: http://getbem.com/naming/
 * blockName
 * cssClassNameModifier: Main modifier
 * props { hasError, hasWarning, hasSuccess, readOnly, disabled}
 *
 * @param blockName
 * @param cssClassNameModifier
 * @param props
 * @param options
 */


var cssPipeline = function cssPipeline() {
  var blockName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'block';
  var cssClassNameModifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var prefix = options.prefix,
      element = options.element;
  var prefixBlockName = "".concat(prefix || cssPrefix).concat(blockName).concat(element ? "__".concat(element) : ''); // PipeLine

  var pipes = !isEmpty(props) ? executePipelines(props) : [];
  var basePipeline = [prefixBlockName].concat(_toConsumableArray(pipes)); // specific classname

  var className = cssClassNameModifier ? _toConsumableArray(basePipeline).join(" ".concat(prefixBlockName, "--")).concat(" ".concat(cssClassNameModifier)) : _toConsumableArray(basePipeline).join(" ".concat(prefixBlockName, "--"));
  return {
    blockName: blockName,
    cssPrefix: cssPrefix,
    prefixBlockName: prefixBlockName,
    cssClassName: className,
    mainModifier: function mainModifier(modifier) {
      return "".concat(className, "--").concat(modifier);
    },
    classNameBlock: function classNameBlock(elementName) {
      var usePrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return "".concat(!usePrefix ? blockName : prefixBlockName, "-").concat(elementName);
    },
    classNameBlockModifier: function classNameBlockModifier(modifierName) {
      var elementBlockName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return "".concat(prefixBlockName, "-").concat(elementBlockName, "--").concat(modifierName);
    },
    classNameElement: function classNameElement(elementName) {
      var elementBlockName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return "".concat(prefixBlockName).concat(elementBlockName ? "-".concat(elementBlockName) : '', "__").concat(elementName);
    },
    classNameModifier: function classNameModifier(modifierName) {
      var elementName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return "".concat(prefixBlockName).concat(elementName ? "__".concat(elementName) : '', "--").concat(modifierName);
    }
  };
};

export { DimsumConfig as D, cssPrefix as a, cssPipeline as c };
//# sourceMappingURL=classNameManager-f813320f.js.map
